
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purpledoor",
      function () {
        return require("private-next-pages/purpledoor/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/purpledoor"])
      });
    }
  